import theme from 'styled-theming';
import styled, { css } from 'styled-components';
import breakpoint, { getZindexByType } from '../../../../utils/style-utils';
import { getTemplateRows, getTemplateRowsSmaller } from '~/utils/layout-utils.js';
import useUIContext from '~/ui/use-ui-context';

const backgroundBrandExceptionStyle = theme('brand', {
	mobilebet: ({ uiContext }) =>
		uiContext.hasHeader &&
		css`
			&::before {
				content: '';
				position: static;
				background: var(--brandContainerBackground);
				background-size: 216px 222px;
				grid-area: header;
				height: ${({ uiContext: uiCtx }) =>
					uiCtx.hasSmallSubHeader
						? `calc(var(--smallerHeaderHeight) + var(--subHeaderHeight))`
						: `var(--smallerHeaderHeight)`};
			}
			${breakpoint.lg`
				&::before {
					position: sticky;
					top: ${({ uiContext: uiCtx }) => (uiCtx.hasStaticHeader ? `var(--regulationHeight)` : 0)};
					height: ${({ uiContext: uiCtx }) =>
						uiCtx.hasSubHeader
							? `calc(var(--headerHeight) + var(--subHeaderHeight))`
							: 'var(--headerHeight)'};
					z-index: ${getZindexByType('header')};
				}
			`}
		`
});

const StyledWrapper = styled.div`
	min-height: 100%;
	display: ${({ isBot }) => (isBot ? 'block' : 'grid')};
	grid-template-columns: repeat(6, 1fr);
	grid-template-rows: ${({ uiContext }) => getTemplateRowsSmaller(uiContext)};
	grid-template-areas:
		'regulations regulations regulations regulations regulations regulations'
		'appbanner appbanner appbanner appbanner appbanner appbanner'
		'header header header header header header'
		'topnav topnav topnav topnav topnav topnav'
		'search search search search search search'
		'subheader subheader subheader subheader subheader subheader'
		'hero hero hero hero hero hero'
		'main main main main main main'
		'footer footer footer footer footer footer';
	${breakpoint.lg`
			overflow-x: unset;
			grid-template-rows: ${({ uiContext }) => getTemplateRows(uiContext)};
		`};
	--unauth-header-position: ${({ uiContext }) => (uiContext.hasProductNav ? `var(--smallerSubHeaderHeight)` : '0')};

	${backgroundBrandExceptionStyle}
`;

const Wrapper = props => {
	const uiContext = useUIContext();
	return <StyledWrapper {...props} uiContext={uiContext} />;
};

export default Wrapper;
